import { useCallback } from 'react';
import { useHasCPQBetaWithLoading, useIsActiveCQTPortal, useIsPostInbound2025Portal, useIsUngatedForCpqUpgrades } from '../../auth/gates';
import useHasCPQCreateScope from './useHasCPQCreateScope';
import useHasCQTCreateScope from './useHasCQTCreateScope';
import useHasSomeDealEditScopes from './useHasSomeDealEditScopes';
import { useScopes } from '../../auth/scopes';
import { getIsPaidPortal } from 'onboarding-scopes';
export const CREATE_QUOTE_ACCESS_TYPE = {
  CPQ: 'CPQ',
  CQT: 'CQT',
  NONE: 'NONE'
};
export const useCreateQuoteAccessType = (ignoreDealEditScopes = false) => {
  const isUngatedForCpqUpgrades = useIsUngatedForCpqUpgrades();
  const isPostInbound2025Portal = useIsPostInbound2025Portal();
  const hasCPQQuoteCreate = useHasCPQCreateScope();
  const hasCQTQuoteCreate = useHasCQTCreateScope();
  const hasSomeDealEditScopes = useHasSomeDealEditScopes();
  const scopes = useScopes();
  const isPaidPortal = getIsPaidPortal(Array.from(scopes));
  const isActiveCQTPortal = useIsActiveCQTPortal();
  const {
    hasCPQBeta: hasCPQQuoteCreateScopeViaPrivateBeta,
    isLoading: isLoadingCPQBeta
  } = useHasCPQBetaWithLoading();
  const canCreateCPQQuote = (hasCPQQuoteCreate || hasCPQQuoteCreateScopeViaPrivateBeta) && (ignoreDealEditScopes || hasSomeDealEditScopes);
  const canCreateCQTQuote = hasCQTQuoteCreate && (ignoreDealEditScopes || hasSomeDealEditScopes);
  const createResponse = useCallback(createQuoteAccessType => {
    return {
      createQuoteAccessType,
      isLoading: isLoadingCPQBeta
    };
  }, [isLoadingCPQBeta]);
  if (isPostInbound2025Portal) {
    /*
    For portals created after inbound 2025, we only allow quotes if the user has the CPQ quote create scope.
    They will not have legacy access.
    */
    if (canCreateCPQQuote) {
      return createResponse(CREATE_QUOTE_ACCESS_TYPE.CPQ);
    }
    return createResponse(CREATE_QUOTE_ACCESS_TYPE.NONE);
  } else {
    /*
    For pre-inbound 2025 portals, we will follow the logic:
    - For users in a paid portal, you can create CPQ quotes if you have the CPQ quote create scope, else, you can create a legacy quote.
    - For users in a free portal, you can create legacy quotes if you were an "active" legacy quotes user before inbound, else, you have no quotes access.
    */
    if (isPaidPortal) {
      if (canCreateCPQQuote) {
        return createResponse(CREATE_QUOTE_ACCESS_TYPE.CPQ);
      }
      if (canCreateCQTQuote) {
        return createResponse(CREATE_QUOTE_ACCESS_TYPE.CQT);
      }
      return createResponse(CREATE_QUOTE_ACCESS_TYPE.NONE);
    } else {
      if (isActiveCQTPortal || !isUngatedForCpqUpgrades) {
        if (canCreateCQTQuote) {
          return createResponse(CREATE_QUOTE_ACCESS_TYPE.CQT);
        }
        return createResponse(CREATE_QUOTE_ACCESS_TYPE.NONE);
      }
    }
    return createResponse(CREATE_QUOTE_ACCESS_TYPE.NONE);
  }
};